query MfaRecoveryCodes($password: String!) {
  mfaRecoveryCodes(password: $password)
}
